import {
  BIZ_PASSPORT_DRIVER,
  BIZ_PASSPORT,
  BIZ_CODE_PASSPORT,
  BIZ_CODE_PASSPORT_DRIVER,
} from './const'
import { is } from 'common-js/util/env'

/**
 * 兜底 biz 区分司乘两端
 */
export const defaultBiz = () => {
  return is.driver ? BIZ_PASSPORT_DRIVER : BIZ_PASSPORT
}

/**
 * 兜底 biz_code 区分司乘两端
 */
export const defaultBizCode = () => {
  return is.driver ? BIZ_CODE_PASSPORT_DRIVER : BIZ_CODE_PASSPORT
}
